import script from "./ErrorBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorBanner.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorBanner.vue?vue&type=style&index=0&id=24d65259&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d65259"]])

export default __exports__